import React, { useState, useEffect } from "react";
import logo from "./images/gif-720.gif";
import "./index.css";

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    // Prevent body scroll when menu is open
    document.body.style.overflow = !isMenuOpen ? 'hidden' : '';
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
    document.body.style.overflow = '';
  };

  return (
    <nav id="top" className={isScrolled ? 'scrolled' : ''}>
      <div className="logo">
        <a href="/" aria-label="Home">
          <img src={logo} alt="Be Safe Keep Safe" />
        </a>
      </div>

      <div 
        className="hamburger" 
        onClick={toggleMenu}
        aria-label="Toggle menu"
        role="button"
        tabIndex={0}
        onKeyPress={(e) => e.key === 'Enter' && toggleMenu()}
      >
        <span className={`hamburger-line ${isMenuOpen ? 'active' : ''}`}></span>
        <span className={`hamburger-line ${isMenuOpen ? 'active' : ''}`}></span>
        <span className={`hamburger-line ${isMenuOpen ? 'active' : ''}`}></span>
      </div>

      <ul className={`menu ${isMenuOpen ? 'active' : ''}`}>
        <li>
          <a href="#header" onClick={closeMenu}>
            Home
          </a>
        </li>
        <li>
          <a href="#services" onClick={closeMenu}>
            What We Do
          </a>
        </li>
        <li>
          <a href="#about" onClick={closeMenu}>
            About Us
          </a>
        </li>
        <li>
          <a href="#about" onClick={closeMenu}>
            Achievements
          </a>
        </li>
        <li>
          <a href="#footer" id="contact" onClick={closeMenu}>
            Contact Us
          </a>
        </li>
      </ul>

      {/* Overlay for mobile menu */}
      {isMenuOpen && (
        <div 
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0, 0, 0, 0.5)',
            zIndex: 999,
          }}
          onClick={closeMenu}
        />
      )}
    </nav>
  );
};

export default Navbar;
